/* Pro purchase-intent signal: one doc per user at proInterest/{uid}, written
 * when they ask to hear about Pro (see ProModal.jsx). Kept as its own
 * top-level collection (rather than a field on the learn doc) so it's a
 * flat, browsable list in the Firestore console for outreach once checkout
 * ships: uid, email, plan, source, timestamp. merge:true so a later click
 * updates plan/source/at without disturbing any ops-added fields (e.g. a
 * hand-added `notified` flag once someone's been emailed).
 *
 * No priceEur any more: the paywall stopped advertising a price, and Firestore
 * REJECTS an undefined field value rather than skipping it (this client sets no
 * ignoreUndefinedProperties), so leaving the parameter in place would have made
 * every write throw. Docs written before the change keep theirs.
 *
 * `platform` ("web" | "android" | "ios") says where the wish was expressed. In
 * the store shells nothing can be bought and no plan is offered, so `plan` is
 * null there and this field is the only thing telling an Android user who
 * wants Pro in the app apart from a web user who met a paused checkout — two
 * different emails to write. Docs from before 2026-10-12 have no such field
 * and are all web. */
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase.js";
import { platform } from "./native.js";

/* `extra` carries the hand-off timestamps (handoffEmailAt / handoffCopyAt, from
 * ProModal): they merge into the same doc so a single row tells the whole story
 * of one user — tapped Pro, emailed themselves the link, copied it, subscribed.
 *
 * Resolves true once the doc is written and false if it could not be, so the
 * paywall only says "recorded" when it was. */
export function saveProInterest({ uid, email, plan, source, courseId, extra = {} }) {
  if (!db || !uid) return Promise.resolve(false);
  return setDoc(
    doc(db, "proInterest", uid),
    {
      uid,
      email: email || null,
      plan: plan || null,
      platform,
      source,
      courseId: courseId || null,
      at: Date.now(),
      ...extra,
    },
    { merge: true }
  ).then(
    () => true,
    (e) => {
      console.warn("proInterest write failed:", e.code || e.message);
      return false;
    }
  );
}
